export function FilterPills({ value, onChange, options, testIdPrefix }) {
  return (
    <div className="flex items-center gap-1 text-xs">
      {options.map(([id, label]) => (
        <button
          key={id || "all"}
          type="button"
          onClick={() => onChange(id)}
          data-testid={`${testIdPrefix}-${id || "all"}`}
          className={`rounded-full px-2.5 py-1 font-semibold transition-colors ${
            value === id ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

// ===========================================================================
// Prospect create / edit dialog
